/**
 * Accessible comparison table rendered from structured data.
 * data: { columns: [string], rows: [[string]] } — first column is the row header.
 * Renders a semantic <table> with <caption>, <th scope> for SEO + a11y.
 */
export function ComparisonTable({ data, caption }) {
  const columns = data?.columns || [];
  const rows = data?.rows || [];
  if (!columns.length || !rows.length) return null;

  return (
    <section className="my-10" data-testid="resource-comparison-table">
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="w-full border-collapse text-sm">
          {caption ? <caption className="sr-only">{caption}</caption> : null}
          <thead>
            <tr className="bg-navy text-left text-white">
              {columns.map((c, i) => (
                <th key={i} scope="col" className="px-4 py-3 font-semibold first:rounded-tl-xl last:rounded-tr-xl">{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri} className="border-t border-slate-100 odd:bg-white even:bg-slate-50/60">
                {row.map((cell, ci) =>
                  ci === 0 ? (
                    <th key={ci} scope="row" className="px-4 py-3 text-left font-medium text-navy">{cell}</th>
                  ) : (
                    <td key={ci} className="px-4 py-3 text-slate-600">{cell}</td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
